import React from 'react'
import { removeStep } from '../../../store/itinerary/itinerarySlice'
import SVGIcon from '../../svg/SVGIcon'
import s from './RemoveStepButton.less'
import useEventCallback from '../../utils/useEventCallback'
import iconUrl from '../../genericComponents/assets/remove.svg'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectIsComputingDone,
  selectIsComputingDoneOrFailed,
  selectItineraryError
} from '../../../store/itinerary/itinerary.selectors'

const RemoveStepButton = ({ stepId }) => {
  const dispatch = useDispatch()
  const onClick = useEventCallback(() => dispatch(removeStep(stepId)))
  const isComputingDone = useSelector(selectIsComputingDoneOrFailed)

  return (
    <div onClick={isComputingDone ? onClick : undefined} className={classNames(s.root, !isComputingDone && 'disabled')}>
      <SVGIcon url={iconUrl} ssrWhite />
    </div>
  )
}

export default RemoveStepButton
